<template>
	<v-dialog
		persistent
		max-width="500"
		:value="value"
		@input="$emit('input', $event.target.value)">
		<dialog-contents
			title="Something Is Not Right"
			:title-color="['red', 'lighten-2']"
			icon="mdi-alert-circle-outline"
			:rightButton="{
				text: 'Login',
				click: loginClick
			}">
			<v-card-text class="pt-5">
				<div v-if="errorMessages && errorMessages.length">
					<p class="text--primary">Worrisome items:</p>
					<ul>
						<li v-for="(message, index) in errorMessages" :key="index">{{ message }}</li>
					</ul>
					<br />
				</div>
				<p class="text--primary">Please contact CraftsMaster for assistance.</p>
			</v-card-text>
		</dialog-contents>
	</v-dialog>
</template>
<script>
import { mapActions } from 'pinia'
import { useUserStore } from '@/store/userStore'
import { useCraftsMasterStore } from '@/store/craftsMasterStore'

export default {
	props: {
		value: Boolean,
		errorMessages: {
			type: Array,
			default: () => {
				return []
			}
		}
	},
	methods: {
		...mapActions(useUserStore, ['logout']),
		...mapActions(useCraftsMasterStore, ['clearErrorMessages']),
		loginClick () {
			this.$emit('input', false)
			this.clearErrorMessages()
			this.logout()
			this.$router.push('/')
		}
	}
}
</script>
